import React from "react";
import { PREVIEW_MODE, PAYMENTS_ENABLED } from "../../data/siteConfig";
export function StatusStrip() {
  return <div className="border-t-[3px] border-cyan bg-navy-900" data-id="element-75" data-mp="9cxjavjvxrq6">
      {(PREVIEW_MODE || !PAYMENTS_ENABLED) && <p className="container-x flex min-h-9 items-center justify-center gap-2.5 py-2 text-center text-[12px] font-semibold tracking-wide text-ice/85 sm:text-[13px]" data-id="element-76" data-mp="e9e7tquzy83s">
          <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-orange" aria-hidden="true" data-id="element-77" data-mp="n42bxdou5jr0" />
          {PREVIEW_MODE ? "Preview — checkout not open" : "Checkout linked · payment setup in progress"}
        </p>}
    </div>;
}